(() => {
  const positionMap = () => {
    const landing = document.querySelector('.rr-home #travelers-landing');
    const map = document.querySelector('#bazaar-map');
    if (!landing || !map) return;
    landing.insertAdjacentElement('afterend', map);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', positionMap, { once: true });
  } else {
    positionMap();
  }

  document.addEventListener('shopify:section:load', positionMap);
})();
